import { DialogComponent, DialogOpenEvent, DialogCloseEvent } from '@theme/dialog';

class FdSizeGuideComponent extends DialogComponent {
  connectedCallback() {
    this.nestedInDialog = Boolean(this.parentElement?.closest('dialog'));
    if (this.nestedInDialog) {
      this.hidden = true;
      return;
    }
    super.connectedCallback();
    this.addEventListener(DialogOpenEvent.eventName, this.handleOpen);
    this.addEventListener(DialogCloseEvent.eventName, this.handleClose);
    this.querySelectorAll('.fd-size-guide__chart table').forEach((table) => {
      Array.from(table.rows).forEach((row, rowIndex) => {
        Array.from(row.cells).forEach((cell, cellIndex) => {
          if (rowIndex !== 0 && cellIndex !== 0) return;
          if (cell.tagName === 'TH') return;
          const heading = document.createElement('th');
          for (const attribute of cell.attributes) heading.setAttribute(attribute.name, attribute.value);
          if (!heading.hasAttribute('scope')) heading.scope = rowIndex === 0 ? 'col' : 'row';
          heading.innerHTML = cell.innerHTML;
          if (rowIndex === 0 && cellIndex === 0 && !cell.textContent.trim()) {
            heading.textContent = this.dataset.sizeColumnLabel || '';
          }
          cell.replaceWith(heading);
        });
      });
    });
  }

  disconnectedCallback() {
    if (this.nestedInDialog) return;
    this.removeEventListener(DialogOpenEvent.eventName, this.handleOpen);
    this.removeEventListener(DialogCloseEvent.eventName, this.handleClose);
    super.disconnectedCallback();
    if (this.refs.dialog?.open) {
      this.refs.dialog.close();
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
    }
  }

  handleOpen = () => this.refs.trigger?.setAttribute('aria-expanded', 'true');

  handleClose = () => {
    this.refs.trigger?.setAttribute('aria-expanded', 'false');
    this.refs.trigger?.focus({ preventScroll: true });
  };
}

if (!customElements.get('fd-size-guide-component')) {
  customElements.define('fd-size-guide-component', FdSizeGuideComponent);
}
